import { render } from "./QRCodeComponent.vue?vue&type=template&id=8d927978&scoped=true"
import script from "./QRCodeComponent.vue?vue&type=script&lang=js"
export * from "./QRCodeComponent.vue?vue&type=script&lang=js"

import "./QRCodeComponent.vue?vue&type=style&index=0&id=8d927978&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d927978"]])

export default __exports__